/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const accordion = () => {
  if (!document.accordionEnabled) {
    document.accordionEnabled = [];
  }
  const accordions = document.querySelectorAll('.accordion-js');
  accordions.forEach(container => {
    const btns = container.querySelectorAll('.accordion-btn-js');
    btns.forEach(btn => {
      if (!document.accordionEnabled.includes(btn.dataset.target)) {
        document.accordionEnabled.push(btn.dataset.target);
        btn.addEventListener('click', e => {
          const classTargetItem = `.${e.currentTarget.getAttribute(
            'data-target',
          )}`;
          const targetItem = document.querySelector(classTargetItem);
          const { lang } = document.documentElement;
          const expand = lang === 'pl' ? 'Rozwiń odpowiedź' : 'Expand answer';
          const collapse = lang === 'pl' ? 'Zwiń odpowiedź' : 'Hide';

          if (!targetItem.classList.contains('is-active')) {
            const acc = document.querySelectorAll(
              '.c-accordion__description.is-active',
            );
            acc.forEach(element => {
              element.style.height = '0px'; // eslint-disable-line no-param-reassign
              element.classList.remove('active');
              if (element.classList.contains('change-text-btn-js')) {
                const textShow = element.getAttribute('data-textshow')
                  ? element.getAttribute('data-textshow')
                  : expand;
                element.innerHTML = `<span class="text">${textShow}</span>`; // eslint-disable-line no-param-reassign
              }
              element.addEventListener(
                'transitionend',
                () => {
                  element.classList.remove('is-active');
                },
                { once: true },
              );
              const menu = document.querySelector('.js-candidate-inf-menu');
              const mobile = window.matchMedia('(max-width: 767px)').matches;
              let offset = 0;
              if (menu && mobile) {
                offset = menu.getBoundingClientRect().height;
              }
              window.scrollTo({
                top:
                  element.getBoundingClientRect().top + window.scrollY - offset,
                left: 0,
                behavior: 'smooth',
              });
            });
            targetItem.classList.add('is-active');
            e.currentTarget.classList.add('active');
            if (e.currentTarget.classList.contains('change-text-btn-js')) {
              const textHide = e.currentTarget.getAttribute('data-texthide')
                ? e.currentTarget.getAttribute('data-texthide')
                : collapse;
              e.currentTarget.innerHTML = `<span class="text">${textHide}</span>`;
            }
            targetItem.style.height = 'auto';
            const height = `${targetItem.clientHeight}px`;
            targetItem.style.height = '0px';
            setTimeout(() => {
              targetItem.style.height = height;
            }, 0);
          } else {
            targetItem.style.height = '0px';
            e.currentTarget.classList.remove('active');
            if (e.currentTarget.classList.contains('change-text-btn-js')) {
              const textShow = e.currentTarget.getAttribute('data-textshow')
                ? e.currentTarget.getAttribute('data-textshow')
                : expand;
              e.currentTarget.innerHTML = `<span class="text">${textShow}</span>`;
            }
            targetItem.addEventListener(
              'transitionend',
              () => {
                targetItem.classList.remove('is-active');
              },
              { once: true },
            );
          }
        });
      }
    });
  });
};

export default accordion;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/accordion.js